import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge, Tooltip, OverlayTrigger, Col, Tab, Nav } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css'; 
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import bgimage from '../../../../images/items/items.jpg';

// ✅ Utility Function
const getDaysAgo = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    const diffTime = Math.abs(new Date() - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
};

const KitchenRoom = () => {
    const onInit = () => {
        // console.log('lightGallery initialized');
    };

    const [key, setKey] = useState('manage_stock');
    const [stockData, setStockData] = useState([]);

    // ✅ Simulate fetching data (replace with API later)
    useEffect(() => {
        const mockData = [
            {
                sno: 1,
                rawmaterial_name: "Basmathi Rice",
                rawmaterial_category: "Grains",
                brand: "India Gate",
                expiry_period: 30,
                current_stock: 50,
                current_stock_unit_slug: "kg",
                purchased_date: "2025-11-10",
                purchased_qty: 100,
                consumed_qty: 5,
                consumed_unit_slug: "kg",
                consumed_date: "2025-11-12",
                stock_level_status: 0,
                image_url: null
            },
            {
                sno: 2,
                rawmaterial_name: "Tomato",
                rawmaterial_category: "Vegetable",
                brand: "Fresh Farm",
                expiry_period: 7,
                current_stock: 10,
                current_stock_unit_slug: "kg",
                purchased_date: "2025-11-09",
                purchased_qty: 25,
                consumed_qty: 8,
                consumed_unit_slug: "kg",
                consumed_date: "2025-11-12",
                stock_level_status: 1,
                image_url: null
            }
        ];
        setStockData(mockData);
    }, []);

    // ✅ Dummy event handlers
    const handleModalToggle_History = () => {
        swal.fire("History Clicked", "You clicked the history button.", "info");
    };

    const handleResolveReason = () => {
        swal.fire({
            title: "Resolve Reason",
            input: "textarea",
            inputPlaceholder: "Enter resolve reason...",
            showCancelButton: true,
            confirmButtonText: "Submit",
            cancelButtonText: "Cancel"
        }).then((result) => {
            if (result.isConfirmed) {
                swal.fire("Submitted!", "Resolve reason recorded.", "success");
            }
        });
    };

    return (
        <>
            {/* Page Header */}
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Kitchen Room</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Stock Management</li>
                    </ol>
                </div>
            </div>

            {/* Tabs */}
            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li">
                                <Nav.Link eventKey="manage_stock">
                                    <i className="fa-regular fa-user me-2" />
                                    <label className="ms-2 fs-6">Manage Stock</label>
                                </Nav.Link>
                            </Nav.Item>
                            {/* <Nav.Item as="li">
                                <Nav.Link eventKey="manage_history">
                                    <i className="fa-solid fa-list-check me-2" />
                                    <label className="ms-2 fs-6">Stock Checklist History</label>
                                </Nav.Link>
                            </Nav.Item> */}
                        </Nav>

                        <Tab.Content className="pt-4">
                            {/* Manage Stock */}
                            <Tab.Pane eventKey="manage_stock">
                                <div className="table-container">
                                    <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                        <thead>
                                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                <th className='min-w-100px'>Raw Material</th>
                                                <th className='min-w-100px'>Brand / Expiry Day</th>
                                                <th className='min-w-100px text-center'>Current Stock</th>
                                                <th className='min-w-50px text-center'>Buy Date / Qty</th>
                                                <th className='min-w-100px text-center'>Consumption Qty / Day</th>
                                                <th className='min-w-100px text-center'>Stock Level</th>
                                                <th className='min-w-100px text-center'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold fs-7">
                                            {stockData.length > 0 ? (
                                                stockData.map(stock => (
                                                    <tr key={stock.sno}>
                                                        <td>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                                    <div data-src={stock.image_url || bgimage} className='border rounded px-1 py-0'>
                                                                        <img src={stock.image_url || bgimage} alt={stock.rawmaterial_name} className='cursor-pointer w-45px h-45px' />
                                                                    </div>
                                                                </LightGallery>
                                                                <div>
                                                                    <label className='text-black font-w400 fs-7'>{stock.rawmaterial_name}</label>
                                                                    <div><label className="fs-8 text-dark font-w600">{stock.rawmaterial_category}</label></div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td align='center'>
                                                            <Badge bg="info" className='fw-semibold fs-7 text-white'>{stock.brand || '-'}</Badge>
                                                            <div className='mt-1'><label className='text-black font-w400 fs-7'>{stock.expiry_period || '-'} Days</label></div>
                                                        </td>
                                                        <td align='center'>
                                                            <label className='text-black font-w400 fs-7 text-center'>
                                                                {stock.current_stock ? parseFloat(stock.current_stock).toFixed(2) : '0.00'} {stock.current_stock_unit_slug}
                                                            </label>
                                                        </td>
                                                        <td align='center'>
                                                            <Badge bg="none" className='fw-semibold fs-7 text-danger border border-danger'>{stock.purchased_date}</Badge>
                                                            <div className='mt-1'>
                                                                <label className='text-black font-w400 fs-7'>{stock.purchased_qty ? parseFloat(stock.purchased_qty).toFixed(2) : '0.00'} {stock.current_stock_unit_slug}</label>
                                                            </div>
                                                        </td>
                                                        <td align='center'>
                                                            <label className='text-black font-w400 fs-7'>
                                                                {stock.consumed_qty ? parseFloat(stock.consumed_qty).toFixed(2) : '0.00'} {stock.consumed_unit_slug}
                                                            </label>
                                                            <div className='mt-1'>
                                                                {stock.consumed_date ? (
                                                                    <Badge bg="none" className="fw-semibold fs-7 text-primary border border-primary">
                                                                        {getDaysAgo(stock.consumed_date)} {getDaysAgo(stock.consumed_date) === 1 ? 'Day' : 'Days'}
                                                                    </Badge>
                                                                ) : (
                                                                    <Badge bg="none" className="fw-semibold fs-7 text-primary border border-primary">-</Badge>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td align="center">
                                                            {stock.stock_level_status === 0 && <Badge bg="warning" className="text-white fs-7 py-0 px-1">Available</Badge>}
                                                            {stock.stock_level_status === 1 && <Badge bg="danger" className="text-white fs-7 py-0 px-1">Low</Badge>}
                                                            {stock.stock_level_status === 2 && <Badge bg="success" className="text-white fs-7 py-0 px-1">High</Badge>}
                                                        </td>
                                                        {/* <td align='center'>
                                                             <OverlayTrigger trigger="hover" placement="bottom"
                                                                overlay={<Tooltip><span className='fs-8 text-white fw-semibold'>Consumption History</span></Tooltip>}>
                                                                <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={handleModalToggle_History}>
                                                                    <i className="fa-solid fa-clock-rotate-left fs-6 mt-1"></i>
                                                                </Button>
                                                            </OverlayTrigger>  
                                                        </td> */}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr><td colSpan="7" className="text-center">No records found.</td></tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </Tab.Pane>

                            {/* Manage History */}
                            <Tab.Pane eventKey="manage_history">
                                <div className="table-container">
                                    <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                        <thead>
                                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                <th className='min-w-100px text-start'>Date</th>
                                                <th className='min-w-100px'>Mismatched Raw Material</th>
                                                <th className='min-w-100px'>Description</th>
                                                <th className='min-w-100px'>Resolve Reason</th>
                                                <th className='min-w-100px'>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold fs-7">
                                            <tr>
                                                <td><Badge bg="none" className='text-info border border-info fs-7 py-0 px-1'>10-May-2025</Badge></td>
                                                <td><label className='text-black font-w400 fs-7'>Basmathi Rice</label></td>
                                                <td><label className='text-black font-w400 fs-7'>-</label></td>
                                                <td>
                                                    <OverlayTrigger trigger="hover" placement="bottom"
                                                        overlay={<Tooltip><span className='fs-8 text-white fw-semibold'>Lorem Ipsum description text here</span></Tooltip>}>
                                                        <label className='text-black font-w400 fs-7 w-250px text-truncate'>
                                                            Lorem Ipsum is simply dummy text used in printing and typesetting.
                                                        </label>
                                                    </OverlayTrigger>
                                                </td>
                                                <td><Badge bg="danger" className='text-white fs-8 py-0 px-1'>Resolved</Badge></td>
                                            </tr>

                                            <tr>
                                                <td><Badge bg="none" className='text-info border border-info fs-7 py-0 px-1'>10-May-2025</Badge></td>
                                                <td><label className='text-black font-w400 fs-7'>Tomato</label></td>
                                                <td><label className='text-black font-w400 fs-7'>-</label></td>
                                                <td><label className='text-black font-w400 fs-7'>-</label></td>
                                                <td>
                                                    <Badge bg="success" onClick={handleResolveReason} className='text-white fs-8 py-0 px-1 cursor-pointer'>
                                                        Resolve
                                                    </Badge>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col>
        </>
    );
};

export default KitchenRoom;
